//Route Name
export const MAIN = "MAIN";
export const ABOUTUS = "ABOUTUS";
export const RECOMMENDATION = "RECOMMENDATION";
export const HISTORY = "HISTORY";
export const LOGIN = "LOGIN";
export const SIGNUP = "SIGNUP";

//Mode Name
export const INTRO = "INTRO";
export const Q1 = "Q1";
export const Q2 = "Q2";
export const Q3 = "Q3";
export const Q4 = "Q4";
export const Q5 = "Q5";
export const FINISH = "FINISH";
export const RESULT = "RESULT";

//Answer Name (Q3~Q5)
export const DISTANCE = "T1";
export const SUBWAY = "T2";
export const COST = "T3";
export const SAFETY = "T4";
export const HOUSE = "T5";

//ChartMode Name
export const ALL = "ALL";
export const BAR = "BAR";
export const WORDCLOUD = "WORDCLOUD";
export const PIE = "PIE";

//BarChart Category Name
export const MONTHRESERV = "MONTHRESERV";
export const MONTHPAY = "MONTHPAY";
export const RESERV = "RESERV";
